export default class FormatterUtils {
  static Months = [
    '{Jan}',
    '{Feb}',
    '{Mar}',
    '{Apr}',
    '{May}',
    '{Jun}',
    '{Jul}',
    '{Aug}',
    '{Sep}',
    '{Oct}',
    '{Nov}',
    '{Dec}',
  ];

  static currency(value = 0, currency) {
    const formatter = new Intl.NumberFormat('en-US', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });

    const formatted = currency
      ? `${currency} ${formatter.format(value < 0 ? -1 * value : value)}`
      : formatter.format(value < 0 ? -1 * value : value);

    if (value < 0) {
      return `-${formatted}`;
    }

    return formatted;
  }

  static fromCurrencyToValue(currencyValue) {
    return currencyValue.replaceAll(',', '');
  }

  static shortDate(dateString = '') {
    const d = new Date(dateString);

    const day = d.getDate();

    return `${FormatterUtils.Months[d.getMonth()]} ${
      day < 10 ? '0' : ''
    }${day}`;
  }

  static longDate(dateString = '') {
    const d = new Date(dateString);

    const day = d.getDate();
    const month = d.getMonth() + 1;
    const year = d.getFullYear();

    const fDay = String(day).padStart(2, '0');
    const fMonth = String(month).padStart(2, '0');
    return `${fDay}/${fMonth}/${year}`;
  }

  static formatDateCustom(
    inputDate,
    t,
    format = 'DD MMM YYYY - hh:mm AA',
    monthNumberFormat = false,
  ) {
    const d = new Date(inputDate);

    const year = d.getFullYear();
    const monthNumber = d.getMonth() + 1;
    const monthFormat = monthNumber < 10 ? '0' + monthNumber : monthNumber;
    const month = FormatterUtils.Months[d.getMonth()]
      .replace('{', '')
      .replace('}', '');
    const day = d.getDate();
    const hours = d.getHours();
    const minutes = d.getMinutes();
    const period = hours < 12 ? 'AM' : 'PM';

    const formattedDate = format
      .replace('YYYY', year)
      .replace('MMM', monthNumberFormat ? monthFormat : t(month))
      .replace('DD', day < 10 ? '0' + day : day)
      .replace('hh', hours % 12 || 12)
      .replace('mm', minutes < 10 ? '0' + minutes : minutes)
      .replace('AA', period);

    return formattedDate;
  }

  static cardNumber(digits = '') {
    return `···· ${digits ? digits.slice(-4) : ''}`;
  }
}
